import Reveal from "@/components/base/Reveal";
import SubscribeForm from "@/components/feature/SubscribeForm";

const benefits = [
  { icon: "ri-flashlight-line", text: "重要前瞻发布时，第一时间收到邮件提醒" },
  { icon: "ri-filter-3-line", text: "可只订阅你关注的分类，避免无关打扰" },
  { icon: "ri-lock-line", text: "邮箱仅用于发送提醒，不做任何其他用途" },
];

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="scroll-mt-24 bg-primary-500">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="inline-flex items-center gap-2 rounded-full bg-primary-950/30 px-3 py-1.5 text-xs font-semibold text-background-50">
                <i className="ri-notification-3-line" />
                蹲守提醒
              </p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
                不想错过任何大瓜，就提前蹲好位置
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-primary-50 md:text-base">
                留一个邮箱，我们会在发布重要前瞻时给你一封简短提醒。不刷屏、不营销，只在对的时间告诉你该看什么。
              </p>
              <ul className="mt-7 space-y-4">
                {benefits.map((benefit) => (
                  <li key={benefit.text} className="flex items-start gap-3 text-sm text-primary-50">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-950/30 text-background-50">
                      <i className={benefit.icon} />
                    </span>
                    {benefit.text}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={120}>
              <SubscribeForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}